import { FormikHelpers } from "formik";
import { ChangeEvent } from "react";

export const SUBMIT = "submit";
export const addToCart = "addToCart";
export const ADD_TO_CART = "ADD_TO_CART";
export const ADD_TO_CART_SUCCESS = "ADD_TO_CART_SUCCESS";
export const GET_CART_ITEMS_LIST = "GET_CART_ITEMS_LIST";
export const GET_CART_ITEMS_LIST_SUCCESS = "GET_CART_ITEMS_LIST_SUCCESS";
export const UPDATE_CART = "UPDATE_CART";
export const UPDATE_CART_SUCCESS = "UPDATE_CART_SUCCESS";
export const DELETE_CART_ITEM = "DELETE_CART_ITEM";
export const DELETE_CART_ITEM_SUCCESS = "DELETE_CART_ITEM_SUCCESS";
export const CLEAR_CART = "CLEAR_CART";
export const CLEAR_CART_SUCCESS = "CLEAR_CART_SUCCESS";

export interface SwitchInSchemesResponse {
  Dtinformation: SwitchInDtinformation[];
  DtData: SwitchInDtData[];
}

interface SwitchInOption extends SwitchInDtData {
  label: string;
  value: string;
}

export type SwitchInOptions = Omit<SwitchInOption, "fm_schdesc">[];

interface SwitchInDtData {
  fm_fund: string;
  fm_scheme: string;
  fm_plan: string;
  fm_option: string;
  fm_schdesc: string;
  fm_plnmode: string;
  fm_newpur: string;
  KYC: string;
  SIPminamt: string;
  multiples: number;

  combo_flag?: string;
  combo_lable?: string;
  combo_disclaimer?: string;
}
enum SwitchInKyc {
  N = "N",
}

interface SwitchInDtinformation {
  Error_Code: string;
  Error_Message: string;
  EncryptionFlag: SwitchInKyc;
}

export interface InvestorFundDetails {
  Fund: string;
  FundDesc: string;
  Sch: string;
  SchDesc: string;
  Pln: string;
  PlnDesc: string;
  Opt: string;
  OptDesc: string;
  Acno: number;
  BalUnits: number;
  LastNAV: number;
  CurValue: string;
  LastNavDate: string;
  pFlag: string;
  rFlag: string;
  sFlag: string;
  MinAmt: number;
  SchType: string;
  Kyc1: string;
  PmodeValue: string;
  PmodeDesc: string;
  Mobile: string;
  pSchFlg: string;
  rSchFlg: string;
  sSchFlg: string;
  SchDesc1: string;
  TaxSaverFlag: string;
  AadharFlag: string;
  brokercd: string;
  subbrokercd: null;
  sipFlag: string;
  SubCategory: string;
  Investment_Flag: string;
  PAN: string;
  CostValue: string;
  GainValue: string;
  RedMinAmt: number;
  sipSchFlg: string;
  notallowed_flag: string;
  sipminamt: number;
  Fund_CostValue: number;
  Fund_CurValue: number;
  Fund_GainValue: string;
  minorflag: string;
  InvName: string;
  insta_red_flag: string;
  insta_red_min_amt: number;
  primary_minor_flag: string;
  guardian_pan: string;
  email: string;
  multibrokflg: string;
  stpflg: string;
  swpflg: string;
  combo_flag: string;
  combo_lable: string;
  combo_disclaimer: string;
  multiples: number;
}

export interface BankDetails {
  Fund: string;
  foliono: number;
  bnkcode: string;
  bnkname: string;
  bnkactype: string;
  bnkacno: string;
  defaultbnk: string;
  ifsccode: string;
  branch: string;
  Addr: string;
  pan: string;
  UMRN: string;
}

export interface InvestorDetails {
  bankDetails: Array<BankDetails>;
  fundDetails: Array<InvestorFundDetails>;
}

export interface Option {
  label: string;
  value: string;
}
interface SipScheme {
  label: string;
  value: string;
  scheme: string;
  plan: string;
  option: string;
  sipMinAmount: string | number;
  newPurchaseMinAmount: string | number;
  multiples: string | number;
  combo_flag: string;
  combo_disclaimer: string;
}

interface Frequency extends Option {
  minimumInstallments: string | number;
}

export type Options = Array<Option>;
export type SipSchemeOptions = Array<SipScheme>;
export type FrequencyOptions = Array<Frequency>;

export interface CartItems<T extends TransactionType>
  extends Array<CartItem<T>> {}

export type TransactionType = keyof CartItemsMap;

export interface CartResponse<T = ""> {
  cartId: string;
  pan: string;
  arnCode: string;
  investorName: string;
  status: string;
  paymentUrl: null;
  paymentUrlStatus: null;
  bulkOrderId: number;
  mobile: string;
  email: string;
  createdAt: Date;
  cartItems: CartItem<T>[];
}

export interface CartItemsMap {
  STP: STPPayload;
  RED: RedemptionPayload;
  SWITCH: SwitchPayload;
  APL: AdditionalPurchasePayload;
  NPL: NewPurchasePayload;
  ISIP: SIPPayload;
  SIN: SIPPayload;
  SINI: SIPPayload;

  SWP: SWPPayload;
}

export interface CartItem<T> {
  cartItemId: string;
  cartId: string;
  pan: string;
  arnCode: string;
  investorName: string;
  fund: string;
  investmentAmount: number;
  units: number;
  transactionType: T;
  paymentStatus: string;
  payload: T extends TransactionType
    ? CartItemsMap[T] & {
        newPurchaseSipType?: "SIPN";
        invCategory?: "11" | "20";
        perpetual?: boolean;
        isKYCInvalid: boolean;
        kycMessage: string;
      }
    : string;
  ihno: number;
  status: string;
  mobile: string;
  email: string;
  createdAt: Date;
}

interface SWPPayload {
  pan: string;
  mobile: string;
  email: string;
  folio: number;
  arn: string;
  fund: string;
  scheme: string;
  plan: string;
  option: string;
  amount: number;
  euin: string;
  euinDeclaration: string;
  withdrawalType: string;
  transactionType: "SWP";
  branch: string;
  dcr: string;
  userId: string;
  frequency: string;
  noOfWithdrawals: number;
  investorName: string;
  swpFrequency: string;
  swpOption: string;
  swpEndDate: string;
  swpStartDate: string;
  swpDay: number;
  arnCode: string;
  schemeName: string;
  fmdesc: string;
  plandesc: string;
  schdesc: string;
  optiondesc: string;
}

interface STPPayload {
  pan: string;
  mobile: string;
  email: string;
  folio: number;
  fund: string;
  category: string;
  scheme: string;
  plan: string;
  option: string;
  toScheme: string;
  toPlan: string;
  toOption: string;
  amount: string;
  arn: string;
  subArn: string;
  subBroker: string;
  euin: string;
  euinDeclaration: string;
  dcr: string;
  transactionType: "STP";
  userId: string;
  stpOption: string;
  frequency: string;
  stpDay: number;
  stpStartDate: string;
  stpEndDate: string;
  noOfTransfers: string;
  arnCode: string;
  investorName: string;
  switchOutSchemeName: string;
  switchInSchemeName: string;
  fmdesc: string;
  plandesc: string;
  schdesc: string;
  optiondesc: string;
}

interface RedemptionPayload {
  pan: string;
  mobile: string;
  email: string;
  fund: string;
  scheme: string;
  plan: string;
  option: string;
  amount: string;
  units: number;
  arnCode: string;
  subArn: string;
  subBroker: string;
  euin: string;
  euinDeclaration: string;
  partial: boolean;
  dcr: string;
  userId: string;
  folio: string;
  ifscCode: string;
  bankName: string;
  bankAccountNumber: string;
  bankAccountType: string;
  transactionType: "RED";
  schemeName: string;
  investorName: string;
  fmdesc: string;
  plandesc: string;
  schdesc: string;
  optiondesc: string;
}

interface SwitchPayload {
  pan: string;
  mobile: string;
  email: string;
  folio: number;
  fund: string;
  scheme: string;
  category: string;
  plan: string;
  option: string;
  toScheme: string;
  toPlan: string;
  toOption: string;
  amount: string;
  units: number;
  arn: string;
  subArn: string;
  subBroker: string;
  euin: string;
  euinDeclaration: string;
  partial: boolean;
  transactionType: "SWITCH";
  userId: string;
  dcr: string;
  arnCode: string;
  investorName: string;
  switchOutSchemeName: string;
  switchInSchemeName: string;
  fmdesc: string;
  plandesc: string;
  schdesc: string;
  optiondesc: string;
}

export type TransactionHistoryTable = TransactionHistory[];
export interface TransactionHistory {
  dco_cart_id: null | string;
  dco_updated_at: string;
  dco_status: string;
  status: string;
  dco_ihno: string;
  isDotNet: boolean;
  orders: Order[];
  dco_distributor?: string;
}

export interface Order {
  dco_cart_id: number | null;
  dco_cart_item_id: number | null;
  orderId: number | null;
  dco_inv_name: null | string;
  dco_fund: string;
  dco_status: string;
  dco_created_at: Date;
  dco_updated_at: Date;
  investment_type: string;
  scheme: string;
  scheme2: string;
  dashboard_status: string;
  amount: number;
  units: number | null;
  dco_ihno: string;
  Link?: string;
  link?: string;
  dco_distributor?: string;
  dco_inv_mobile?: string;
  sipamount?: number;
}

interface AdditionalPurchasePayload {
  pan: string;
  mobile: string;
  email: string;
  folio: number;
  fund: string;
  category: string;
  purchaseType: string;
  scheme: string;
  plan: string;
  option: string;
  amount: string;
  arnCode: string;
  subArn: string;
  subBroker: string;
  euin: string;
  euinDeclaration: string;
  userId: string;
  transactionType: string;
  dcr: string;
  investorName: string;
  schemeName: string;
  fmdesc: string;
  plandesc: string;
  schdesc: string;
  optiondesc: string;
  combo?: boolean;
}
export interface NewPurchasePayload {
  investorName: string;
  pan: string;
  mobile: string;
  category: string;
  familyMobileFlag: string;
  email: string;
  familyEmailFlag: string;
  fund: string;
  scheme: string;
  plan: string;
  option: string;
  amount: string;
  arnCode: string;
  subArn: string;
  subBroker: string;
  euin: string;
  euinDeclaration: string;
  userId: string;
  transactionType: "NPL";
  combo?: boolean;
  dcr: string;
  schemeName: string;
}

export interface SIPPayload {
  investorName: string;
  pan: string;
  folio: number;
  fund: string;
  scheme: string;
  plan: string;
  option: string;
  arnCode: string;
  subArn: string;
  euinDeclaration: string;
  dcr: string;
  userId: string;
  subBroker: string;
  euin: string;
  amount: number;
  remarks: string;
  sipFrequency: string;
  sipStartDate: string;
  sipEndDate: string;
  noOfInstallments: number;
  perpetual: boolean;
  modeOfRegistration: "ISIP" | "KOTM" | "AOTM" | "";
  installmentAmount: number;
  schemeName: string;
  category: string;
  paymentMode: string;
  sipDay: number;
  mobile: string;
  email: string;
  transactionType: string;
  combo?: boolean;
  newPurchaseSipType?: "SIPN";
  familyEmailFlag?: string;
  familyMobileFlag?: string;
  invCategory: "11" | "20";
  isFreedom?: boolean;
  swpStartDate?: string;
  swpEndDate?: string;
  tenure?: string;
  swpSchemeName?: string;
  withdrawalAmount?: string;
  sipAutoRenewal?:boolean;
}
export interface SIPNew {
  investorName: string;
  pan: string;
  fund: string;
  scheme: string;
  plan: string;
  option: string;
  arnCode: string;
  subArn: string;
  euinDeclaration: string;
  dcr: string;
  userId: string;
  subBroker: string;
  euin: string;
  amount: number;
  remarks: string;
  sipFrequency: string;
  sipStartDate: string;
  sipEndDate: string;
  noOfInstallments: number;
  modeOfRegistration: string;
  installmentAmount: number;
  schemeName: string;
  category: string;
  paymentMode: string;
  sipDay: number;
  mobile: string;
  familyMobileFlag: string;
  email: string;
  familyEmailFlag: string;
  transactionType: string;
}

export interface HandleChange<Values> {
  (values: Values, setValues: React.Dispatch<React.SetStateAction<Values>>): (
    event: OnChange
  ) => unknown;
}

export interface HandleDateChange<Values> {
  (values: Values, helpers: FormikHelpers<Values>): (
    date: Date,
    value: string
  ) => unknown;
}

export interface OnChange extends ChangeEvent<{ name?: string; value: any }> {}
